<template>
    <div>
        <NavBar/>
        <router-view/>
    </div>
</template>

<script>
import NavBar from './includes/NavBar';

export default {
  name: 'DashView',
  components: { NavBar },
  data() {
    return {
    };
  },
  created() {
    if (this.$route.name === 'DashView') {
      this.$router.push({ name: 'home' });
    }
  },
};
</script>

<style scoped>

</style>
